import 'suggestions-jquery/dist/js/jquery.suggestions.min'

$("#full-address").suggestions({
    token: "7adee2df98d5d1b6a1479bded0c82872415afe00",
    type: "ADDRESS",
    /* Вызывается, когда пользователь выбирает одну из подсказок */
    onSelect: function (suggestion) {
        console.log(suggestion)
        $("#zip").show().val(suggestion.data.postal_code)
        $("#state").val(suggestion.data.region)
        if (suggestion.data.city) {
            $("#city").val(suggestion.data.city)
        }
        if (suggestion.data.settlement) {
            if (suggestion.data.settlement_type === 'мкр')
                $("#street").val(suggestion.data.settlement_with_type)
            else
                $("#city").val(suggestion.data.settlement)
        }
        if (suggestion.data.street)
            $("#street").val(suggestion.data.street)
        $("#home").val(suggestion.data.house)
        $("#apartment").val(suggestion.data.flat)
        $("#fias_id").val(suggestion.data.fias_id)
    }
});

$(".dadata-suggestion").suggestions({
    token: "7adee2df98d5d1b6a1479bded0c82872415afe00",
    type: "ADDRESS",
    /* Вызывается, когда пользователь выбирает одну из подсказок */
    onSelect: function (suggestion) {
        console.log(suggestion)
        $("#zip").show().val(suggestion.data.postal_code)
        $("#state").val(suggestion.data.region)
        if (suggestion.data.city) {
            $("#city").val(suggestion.data.city)
        }
        if (suggestion.data.settlement) {
            if (suggestion.data.settlement_type === 'мкр')
                $("#street").val(suggestion.data.settlement_with_type)
            else
                $("#city").val(suggestion.data.settlement)
        }
        if (suggestion.data.street)
            $("#street").val(suggestion.data.street)
        $("#home").val(suggestion.data.house)
        $("#apartment").val(suggestion.data.flat)
        $("#fias_id").val(suggestion.data.fias_id)

        let suggestionId = $(this).attr('dadata-suggestion-id') || null;
        if (suggestionId !== null){
            $("#geo_lat-" + suggestionId.toString()).val(suggestion.data.geo_lat)
            $("#geo_lon-" + suggestionId.toString()).val(suggestion.data.geo_lon)
        }

    }
});
